"use client";
import { jsx } from "react/jsx-runtime";
import { CommandItem } from "../_shadcn-native-components/command.js";
import { useDropdownContext } from "./context.js";
const DropdownBaseItem = ({ isSelected, multiselect, selected, allowClear, onSelect, value, ...props })=>{
    const { values, selectedItems, setValues, setOpen } = useDropdownContext();
    const handleItemSelected = (newValue)=>{
        if (multiselect) {
            const newValues = values.includes(newValue) ? values.filter((item)=>item !== newValue) : [
                ...values,
                newValue
            ];
            if (onSelect) onSelect(newValues);
            if (!selected) setValues(newValues);
        } else {
            const isValueSelected = !!selectedItems.find((selected)=>selected.value === newValue);
            const valueToPropagate = isValueSelected && allowClear ? null : newValue;
            if (onSelect && allowClear) onSelect(valueToPropagate);
            if (onSelect && !allowClear) onSelect(newValue);
            if (!selected) setValues(valueToPropagate ? [
                valueToPropagate
            ] : []);
            setOpen(false);
        }
    };
    return /*#__PURE__*/ jsx(CommandItem, {
        value: value,
        onSelect: handleItemSelected,
        selected: isSelected,
        ...props
    });
};
export { DropdownBaseItem };
